export const Ph = ({ label, className = "", children }) => (
  <div
    className={`relative flex items-center justify-center overflow-hidden rounded-lg border border-dashed border-line bg-ink-2/40 ${className}`}
  >
    {children}
    <span className="pointer-events-none absolute bottom-2 left-3 font-mono text-[8px] tracking-[0.18em] text-ash/70">
      PLACEHOLDER · {label}
    </span>
  </div>
);

/* AppScreenshot · a real phone frame wrapping an actual app capture. */
export const AppScreenshot = ({
  src,
  alt,
  className = "",
  scale = 1,
  clipBottom = 0,
  "data-testid": dataTestId,
  ...rest
}) => (
  <div className={`relative ${className}`} data-testid={dataTestId} {...rest}>
    <div
      className="relative overflow-hidden rounded-[2.2rem] border border-white/15 bg-[#0A0408] shadow-[0_60px_120px_-20px_rgba(0,0,0,0.9)]"
      style={{ padding: `${6 * scale}px` }}
    >
      <div className="mx-auto mb-1.5 h-1 w-14 rounded-full bg-white/15" />
      <div className="overflow-hidden rounded-[1.7rem] border border-line/60 bg-[#0A0408]">
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="block h-auto w-full"
          style={
            clipBottom
              ? {
                  clipPath: `inset(0 0 ${clipBottom * 100}% 0)`,
                  marginBottom: `-${clipBottom * 100}%`,
                }
              : undefined
          }
        />
      </div>
    </div>
  </div>
);


export const BandImage = ({ src = "/assets/band_hero.jpg", alt = "TriKarma Band", className = "", fade = false }) => (
  <img
    src={src}
    alt={alt}
    className={`${fade ? "" : "rounded-lg"} object-cover ${className}`}
    style={{
      mixBlendMode: "lighten",
      ...(fade
        ? {
            WebkitMaskImage: "radial-gradient(ellipse at center, black 52%, transparent 76%)",
            maskImage: "radial-gradient(ellipse at center, black 52%, transparent 76%)",
          }
        : {}),
    }}
  />
);

export const PhoneFrame = ({ className = "", children }) => (
  <div
    className={`relative rounded-[2.1rem] border border-white/20 bg-[#0C060A] p-2.5 ${className}`}
  >
    <div className="mx-auto mb-2 h-1 w-12 rounded-full bg-white/15" />
    <div className="overflow-hidden rounded-[1.5rem] border border-line/60 bg-[#0A0408]">
      {children}
    </div>
    <span className="pointer-events-none absolute -bottom-5 left-3 font-mono text-[8px] tracking-[0.18em] text-ash/70">
      PLACEHOLDER · APP SCREEN
    </span>
  </div>
);

export const SkullCrossbones = ({ className = "", strokeWidth = 1.6 }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3a5.5 5.5 0 0 1 5.5 5.5c0 1.9-1 3.3-2.3 4.1V14.5h-6.4v-1.9A5.1 5.1 0 0 1 6.5 8.5 5.5 5.5 0 0 1 12 3Z" />
    <circle cx="9.9" cy="8.8" r="0.9" />
    <circle cx="14.1" cy="8.8" r="0.9" />
    <path d="M6.2 17.2 L17.8 21 M17.8 17.2 L6.2 21" />
    <circle cx="5.4" cy="16.8" r="0.9" />
    <circle cx="18.6" cy="16.8" r="0.9" />
    <circle cx="5.4" cy="21.4" r="0.9" />
    <circle cx="18.6" cy="21.4" r="0.9" />
  </svg>
);

export const TileShape = ({ label, icon: Icon, className = "", pressed = false }) => (
  <div
    aria-label={label}
    className={`relative flex items-center justify-center rounded-full border-2 transition-all duration-200 ${
      pressed ? "scale-90 border-signal/80" : "border-[#8A8186]/60"
    } ${className}`}
    style={{
      background: "radial-gradient(circle at 35% 30%, #17131A 0%, #050307 72%)",
      boxShadow: "0 10px 26px rgba(0,0,0,0.55)",
    }}
  >
    <span
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 rounded-full"
      style={{ background: "linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 42%)" }}
    />
    {Icon && (
      <Icon
        className={`h-[46%] w-[46%] transition-colors duration-200 ${
          pressed ? "text-signal" : "text-[#A8A2A6]"
        }`}
        strokeWidth={1.6}
      />
    )}
  </div>
);
